import { useEffect } from 'react'
import { RootPopup } from './RootPopup'
import UseDevicePixelRatio from './components/common/hooks/useDevicePixelRatio'
import { LoadingScreen } from './components/layout/loadingScreen'
import { Routers } from './components/routers'
import authProvider from './core/AuthenticationProvider'

const App = () => {
  const devicePixelRatio = UseDevicePixelRatio()

  useEffect(() => {
    if (devicePixelRatio) {
      document.body.style.zoom = `${100 / devicePixelRatio}%`
    }
  }, [devicePixelRatio])

  useEffect(() => {
    authProvider.clearStaleState()
  }, [])

  return (
    <LoadingScreen>
      <Routers>
        <RootPopup />
      </Routers>
    </LoadingScreen>
  )
}

export default App
